"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
var utils_1 = require("./utils");
/**
 * Converts string to AttensiClient or null
 */
exports.stringToAttensiClient = function (str) {
    var client = str.toLowerCase();
    return utils_1.isAttensiClient(client) ? client : null;
};
/**
 * Convert string to AttensiEnvironment or null
 */
exports.stringToEnvironment = function (str) {
    var environment = str.toUpperCase();
    if (environment in _1.AttensiEnvironment) {
        return environment;
    }
    return null;
};
//# sourceMappingURL=converters.js.map